import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { FeedbackDailyPoint } from "@/lib/types";

export function FeedbackChart({ data }: { data: FeedbackDailyPoint[] }) {
  if (data.length === 0) {
    return (
      <div className="flex h-[260px] items-center justify-center text-sm text-muted-foreground">
        피드백 데이터 없음
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
        <XAxis dataKey="date" fontSize={11} />
        <YAxis fontSize={11} />
        <Tooltip />
        <Legend />
        <Bar dataKey="pos" name="👍" stackId="fb" fill="#16a34a" />
        <Bar dataKey="neg" name="👎" stackId="fb" fill="#dc2626" />
      </BarChart>
    </ResponsiveContainer>
  );
}
